import React from 'react';

import { useInstructor } from 'contexts/instructorRole';
import { Button, Dropdown, Icon, IconButton, Stack, TaskTile, Text } from 'shell/components';

const LinkedTemplatesSection = ({ milestone, onClickTemplate, onUnlinkTemplate, onCreateTemplate }) => {
    const { taskTemplates } = useInstructor();

    const handleSelect = (action, templateId) => {
        if (action === 'edit') {
            onClickTemplate(templateId);
        } else if (action === 'delete') {
            onUnlinkTemplate(templateId);
        }
    };

    const linkedTemplates = taskTemplates
        .filter(({ active }) => active)
        .filter((template) => template.milestone_id === milestone.id);

    return (
        <Stack spacing={1}>
            <Text variant={'p2'} weight={'semibold'}>
                Tasks Associated ({linkedTemplates.length})
            </Text>
            {linkedTemplates.map((template) => (
                <TaskTile
                    key={template.id}
                    endComponent={
                        <Dropdown
                            id={`milestone-template-${template.id}-dropdown`}
                            options={[
                                { key: 'edit', value: 'Edit' },
                                { key: 'delete', value: 'Remove Association' },
                            ]}
                            rootComponent={
                                <IconButton
                                    kind={'moreHorizontal'}
                                    size={'small'}
                                    variant={'square'}
                                    onClick={(e) => e.stopPropagation()}
                                />
                            }
                            onSelect={({ key }) => handleSelect(key, template.id)}
                        />
                    }
                    task={template}
                    onClick={() => onClickTemplate(template.id)}
                />
            ))}
            <Button
                data-cy={'add-new-task-template-button'}
                sx={{ alignSelf: 'flex-start' }}
                startIcon={<Icon kind={'add'} />}
                variant={'tertiary'}
                onClick={() => onCreateTemplate(milestone.id)}
            >
                Add New Task Template
            </Button>
        </Stack>
    );
};

export default LinkedTemplatesSection;
